import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { DiscountType } from '../../models/coupons/discount-type-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class DiscountTypeService {

  private serviceName = 'api/discounttype';
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddDiscountType(DiscountTypemodel: DiscountType) {
    return this.http
      .post(`${this.serviceName}`, DiscountTypemodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateDiscountType(DiscountTypemodel: DiscountType){
    //Todo
    return this.http
      .put(`${this.serviceName}`, DiscountTypemodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deleteDiscountType(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getDiscountTypes() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getActiveDiscountTypes() {
    return this.http.get(`${this.serviceName}/GetActiveDiscountTypes`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getDiscountType(id: string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/coupons/discount-type.service.ts